export const handlePromise = <T, E = Error>(
  promise: Promise<T>
): Promise<[E, null] | [null, T]> =>
  promise
    .then<[null, T]>((data: T) => [null, data])
    .catch<[E, null]>((err: E) => [err, null]);

export const isFulfilledPromise = <T>(
  data: PromiseSettledResult<T>
): data is PromiseFulfilledResult<T> => {
  return data.status === 'fulfilled';
};

export const isRejectedPromise = <T>(
  data: PromiseSettledResult<T>
): data is PromiseRejectedResult => {
  return data.status === 'rejected';
};

export const mapFulfilledValue = <T>(data: PromiseFulfilledResult<T>) =>
  data.value;
